import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx-js-style';

@Injectable({
  providedIn: 'root'
})
export class SpreadsheetService {

  constructor() { }

  generateDomainReport(dataList: any, fileNamePrefix: string) {
    
    // 2. Crear la hoja de cálculo a partir del JSON
    const worksheet = XLSX.utils.json_to_sheet(dataList);

    // 3. Definir anchos de columna (Autosize básico)
    if (dataList && dataList.length > 0) {
      // Sacamos cuántas columnas hay leyendo las propiedades del primer elemento
      const numberOfColumns = Object.keys(dataList[0]).length;
      // Creamos un array dinámico donde TODAS las columnas tendrán el mismo ancho (ej: 40)
      worksheet['!cols'] = Array.from({ length: numberOfColumns }, () => ({ wch: 40 }));
    }

    // 4. Aplicar Estilos (Exactamente los tuyos)
    if (worksheet['!ref']) {
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellAddress]) continue;

          // Estilo base
          worksheet[cellAddress].s = {
            font: { name: 'Arial', sz: 10 },
            alignment: { vertical: 'center', horizontal: 'center' }
          };

          // Estilo Cabecera (Fila 0)
          if (R === 0) {
            worksheet[cellAddress].s = {
              ...worksheet[cellAddress].s,
              fill: { fgColor: { rgb: "60BEBF" } },
              font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
              alignment: { horizontal: 'center', vertical: 'center' }
            };
          } 
          // Estilo Filas Pares (Gris alterno)
          else if (R % 2 === 0) {
            worksheet[cellAddress].s = {
              ...worksheet[cellAddress].s,
              fill: { fgColor: { rgb: "EEEEEE" } }
            };
          }
        }
      }
    }

    // 5. Exportar
    const timestamp = this.getTimestampString();
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Activity Report');
    XLSX.writeFile(workbook, `${fileNamePrefix}_${timestamp}.xlsx`);
  }

  /**
   * Genera un timestamp string: YYYYMMDD_HHMMSS
   */
  private getTimestampString(): string {
    const now = new Date();
    const date = now.getFullYear().toString() +
                 (now.getMonth() + 1).toString().padStart(2, '0') +
                 now.getDate().toString().padStart(2, '0');      
    const time = now.getHours().toString().padStart(2, '0') +
                 now.getMinutes().toString().padStart(2, '0') +
                 now.getSeconds().toString().padStart(2, '0');
    return `${date}_${time}`;
  }
  
}
